export default __webpack_public_path__ + "static/media/CancelPatients.cc4c9ede.svg";